import { useEffect } from 'react';

interface UseInstaScrollToThreadEndArgs<T> {
  effectDeps?: any[];
  scrollContainerRef: React.RefObject<T>;
}

export function useInstaScrollToThreadEnd<T extends HTMLElement>({
  effectDeps = [],
  scrollContainerRef,
}: UseInstaScrollToThreadEndArgs<T>) {
  useEffect(() => {
    if (!scrollContainerRef?.current) return;
    // Automatically scrolls to the bottom on content updates
    scrollContainerRef.current.scrollTop = scrollContainerRef?.current.scrollHeight;
  }, effectDeps);
}
